<script lang="ts">
  import { readyCheckElapsedMs, readyTimingStyle } from '../app/ready-check';
  import type { QueueOpponent } from '../matchmaking/queue-connection.svelte';
  import Button from '../ui/Button.svelte';
  import Dialog from '../ui/Dialog.svelte';

  /** Competitive "Match found": accept within the window or decline; the timing matches the ready check. */
  interface Props {
    open: boolean;
    opponent: QueueOpponent | null;
    /** Local milliseconds at which the proposal lapses. */
    endAt: number;
    accepted: boolean;
    accept: () => void;
    decline: () => void;
  }
  let { open, opponent, endAt, accepted, accept, decline }: Props = $props();

  const timing = $derived(readyTimingStyle(readyCheckElapsedMs({ endAt }, Date.now())));
</script>

<Dialog {open} required labelledby="match-found-title">
  <h2 id="match-found-title">Match found</h2>
  {#if opponent}
    <p class="opponent">
      <span aria-hidden="true">{opponent.avatar}</span>
      {opponent.name}{#if opponent.bot}<span class="bot-badge">bot</span>{/if}
    </p>
  {/if}
  {#if accepted}
    <p class="waiting" role="status">Waiting for your opponent…</p>
  {:else}
    {#key endAt}
      <!-- svelte-ignore a11y_autofocus: Accept is the prompt's primary action. -->
      <Button variant="primary" size="big" full class="ready-button" autofocus style={timing} onclick={accept}
        >Accept</Button
      >
    {/key}
    <Button variant="ghost" full onclick={decline}>Decline</Button>
  {/if}
</Dialog>

<style>
  h2 {
    margin: 0 0 12px;
    text-align: center;
  }
  .opponent {
    margin: 0 0 20px;
    text-align: center;
    font-size: 17px;
  }
  .waiting {
    margin: 0;
    text-align: center;
    color: var(--theme-muted-text);
  }
</style>
